import React, { Component } from "react";
import { connect } from "react-redux";
import { getItemHintData } from "../../actions";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";

class ItemHint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setIsOpen: false,
    };
  }

  hovertip(e) {
    this.props.getItemHintData(e);
    this.setState({ setIsOpen: true });
  }

  render() {
    return (
      <Tooltip
        position="top-end"
        trigger="mouseenter"
        theme={"light"}
        delay={500}
        duration={300}
        interactive={true}
        size="big"
        useContext
        open={this.state.setIsOpen}
        onHide={() => {
          this.setState({ setIsOpen: false });
        }}
        html={
          <pre className="jalla-sticky" style={{ textAlign: "left" }}>
            {this.props.itemhintdata}
          </pre>
        }
      >
        <span
          onMouseEnter={() => this.hovertip(this.props.data)}
          className="glyphicon glyphicon-eye-open"
          aria-hidden="true"
        ></span>
      </Tooltip>
    );
  }
}
const mapDispatchToProps = {
  getItemHintData,
};
function mapStateToProps(state) {
  return {
    itemhintdata: state.itemhintdata,
    tooltip: state.tooltip,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ItemHint);



// WEBPACK FOOTER //
// ./src/components/wordsearchscreens/ItemHint.js